<template>
  <div class="card">
    <div class="logs-controls mt-3 mb-4">
      <div class="d-flex">
        <!-- Employer -->
        <div class="d-flex align-items-center w-100">
          <!-- TODO: All Internal Users displays both Admins and Recruiters. -->
          <select
            class="form-control select-records-filter ml-2 w-25"
            @change="handleRecords($event)"
          >
            <option value="all_records">All Records</option>
            <option value="all_candidates">All Candidates</option>
            <option value="all_employers">All Employers</option>
            <option value="all_internal_users">All Internal Users</option>
            <option disabled><span class="separator">──────────────────────────────</span></option>
            <option
              v-for="employer in getEmployersDropdown"
              :key="employer.id"
              :value="employer.id"
            >
              {{ employer.name }}
            </option>
          </select>

          <div class="select-user ml-1 w-50">
            <input
              v-model="searchWordInput"
              @input="debouncedSearch"
              class="form-control"
              placeholder="Search for user"
            />

            <!--  <div v-if="selectedRecordFilter == 'all_candidates'">
              <v-select
                placeholder="Search for user"
                v-model="filterCandidateId"
                :reduce="user => user"
                @input="getLogsByUser"
                :options="allCandidatesList"
                :filterable="false"
                :getOptionLabel="l => `${l.first_name} ${l.last_name}, ${l.email}`"
                @search="onSearch"
              >
                <template slot="option" slot-scope="option">
                  {{ option.first_name }} {{ option.last_name }}, {{ option.email }}
                </template>
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Type atleast 3 characters</div>
                </template>
              </v-select>
            </div> -->

            <!--        <div v-if="selectedRecordFilter != 'all_candidates'">
              <v-select
                v-model="selectedUser"
                :options="usersList"
                :clearable="false"
                :searchable="isSearchable"
              >
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Type atleast 3 characters</div>
                </template>
              </v-select>
            </div> -->
          </div>

          <select class="form-control ml-2 w-25" v-model="action" @change="handleActions($event)">
            <option value>Actions</option>
            <option v-for="action in getLogActions" :key="action.id" :value="action.id">
              {{ action.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="scroller">
      <table class="table table-striped custom-table">
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col">User</th>
            <th nowrap scope="col">Email</th>
            <th nowrap scope="col">Date</th>

            <th nowrap scope="col">IP</th>
            <th nowrap scope="col">Location</th>
            <th nowrap scope="col">Platform</th>
            <th nowrap scope="col">Device</th>
            <th nowrap scope="col">Browser</th>
            <th nowrap scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in getLogs" :key="log.id">
            <td nowrap>{{ log.user_name }}</td>
            <td>
              <div class="text-truncate">{{ log.user_email }}</div>
            </td>
            <td nowrap>
              {{
                log.created_at
                  | formatDate({
                    format: getUserProfile.format_date,
                    timezone: getUserProfile.timezone,
                    hasHourAndMinutes: true,
                  })
              }}
            </td>
            <td>{{ log.ip_address }}</td>
            <td>
              {{ handleLocation(log.location) }}
            </td>
            <td>{{ log.platform }}</td>
            <td>{{ log.device }}</td>
            <td>{{ log.browser }}</td>
            <td class="text-nowrap">{{ log.action_name }}</td>
          </tr>
        </tbody>
      </table>

      <div class="no-data-message mt-5" v-if="isLoading == false && getLogs.length <= 0">
        <p>{{ getLogsListMsg }}</p>
      </div>
    </div>
    <div class="mobile-lists">
      <ul class="list-unstyled">
        <li>
          <div class="d-flex align-items-center">
            <a class="user" href="#">Stefan Dimitrov</a>
            <a class="company ml-auto" href="#">Comstream</a>
          </div>
          <div class="d-flex align-items-center">
            <span class="location">Stockholm, Sweden</span>
            <a class="job-position ml-auto" href="#">Java Developer</a>
          </div>
          <div class="d-flex align-items-center mt-2">
            <span class="logs">Logins: 15</span>
            <span class="logs">Time (H): 15:21</span>
            <span class="logs">Last login: 2020-07-14 12:37</span>
          </div>
        </li>
      </ul>
    </div>

    <span class="bottom-controls ml-auto w-10">
      <div id="pagination" class="desktop-only">
        <!-- Pagination -->
        <Pagination
          :currentPage="getCurrentPage"
          :totalPages="getTotalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @selectPageByNumber="setPageBynumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
          @keyup="keymonitor"
        ></Pagination>
      </div>
    </span>

    <Spinner :isLoading="isLoading" />
  </div>
</template>

<script>
// import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { localStorageHelper } from '@/utils/helpers';

import Pagination from '../../Navigations/Pagination';
import { MESSAGES } from '../../../constants';
import titleMixin from '../../../mixins/titleMixin';
import debounce from 'lodash/debounce';
export default {
  components: { Pagination },
  mixins: [titleMixin],
  title() {
    return 'Logs | Jobshark';
  },
  data: () => ({
    isLoading: false,
    selectedUser: 'User',
    usersList: [],
    allCandidatesList: [],
    filterCandidateId: null,
    isSearchable: true,
    currentPage: 1,
    pageCount: 15,
    selectedRecordFilter: 'all_records',
    action: '',
    searchWord: '',
    searchWordInput: '',
    isEmployerSelected: false,
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveLogs',
      'retrieveLogActions',
      'retrieveUsersByEmployer',
      'retrieveAllInternalUsers',
      'searchCandidateLogs',
    ]),

    doTheSearch() {},
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
    getLogsByUser(evt) {
      /*  console.log('getLogsByUser: ', evt); */

      this.retrieveLogs({
        page: this.currentPage,
        count: this.pageCount,
        record_filter: 'all_candidates',
        action_filter: this.action,
        user_id: 'c077a0e8-99a4-407b-9a45-a32ffbdcb00b',
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          throw err;
        });
    },
    handleActions(e) {
      /*    console.log('action', e.target.value); */
      this.currentPage = 1;
      this.retrieveLogs({
        page: this.currentPage,
        count: this.pageCount,
        record_filter: this.selectedRecordFilter,
        action_filter: this.action,
        js_employer_id: this.selectedRecordFilter,
        search_word: this.searchWordInput,
        js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
      })
        .then(() => (this.isLoading = false))
        .catch(err => {
          this.isLoading = false;
          new Error(err);
        });
    },
    handleLocation(location) {
      const list = [];

      if (location) {
        const res = location.split(',');

        res.forEach(el => {
          if (el != '') {
            list.push(el);
          }
        });

        return list.join(', ');
      } else {
        return 'N/A';
      }
    },
    /* Candidate search */
    onSearch() {
      if (this.searchWordInput.length >= 3) {
        this.currentPage = 1;
        this.retrieveLogs({
          page: this.currentPage,
          count: this.pageCount,
          record_filter: this.selectedRecordFilter,
          action_filter: this.action,
          js_employer_id: this.selectedRecordFilter,
          search_word: this.searchWordInput,
          js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
        });
      }
      if (this.searchWordInput.length === 0) {
        this.currentPage = 1;
        this.retrieveLogs({
          page: this.currentPage,
          count: this.pageCount,
          record_filter: this.selectedRecordFilter,
          action_filter: this.action,
          js_employer_id: this.selectedRecordFilter,
          search_word: this.searchWordInput,
          js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
        });
      }
    },

    handleRecords(e) {
      this.currentPage = 1;
      console.log('handleRecords: ', e.target.value);

      if (e.target.value === 'all_records') {
        this.selectedRecordFilter = e.target.value;
        this.isEmployerSelected = false;
        this.isLoading = true;

        this.retrieveLogActions()
          .then(() => {
            this.retrieveLogs({
              page: this.currentPage,
              count: this.pageCount,
              record_filter: this.selectedRecordFilter,
              action_filter: this.action,
              js_employer_id: this.selectedRecordFilter,
              search_word: this.searchWordInput,
              js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
            })
              .then(res => {
                console.log(res);
                this.isLoading = false;
              })
              .catch(err => {
                this.isLoading = false;
                new Error(err);
              });
          })
          .catch(err => {
            this.isLoading = false;
            new Error(err);
          });

        this.isLoading = false;
        this.isSearchable = true;
      }

      if (e.target.value === 'all_internal_users') {
        this.selectedRecordFilter = e.target.value;
        this.isEmployerSelected = false;
        this.isLoading = true;

        this.retrieveLogActions()
          .then(() => {
            this.isLoading = true;

            this.retrieveLogs({
              page: this.currentPage,
              count: this.pageCount,
              record_filter: this.selectedRecordFilter,
              action_filter: this.action,
              js_employer_id: this.selectedRecordFilter,
              search_word: this.searchWordInput,
              js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
            })
              .then(() => {
                this.isLoading = false;

                this.retrieveAllInternalUsers().then(() => {
                  this.usersList =
                    this.getAllInternalUsers.map(internalUser => {
                      return `${internalUser.first_name} ${internalUser.last_name}, ${internalUser.email}`;
                    }) || [];
                });
              })
              .catch(err => {
                this.isLoading = false;
                new Error(err);
              });
          })
          .catch(err => {
            this.isLoading = false;
            new Error(err);
          });

        this.isSearchable = false;
      }

      if (e.target.value === 'all_candidates') {
        this.selectedRecordFilter = e.target.value;
        this.isEmployerSelected = false;
        this.isLoading = true;

        this.retrieveLogActions()
          .then(() => {
            this.isLoading = false;

            this.retrieveLogs({
              page: this.currentPage,
              count: this.pageCount,
              record_filter: this.selectedRecordFilter,
              action_filter: this.action,
              js_employer_id: this.selectedRecordFilter,
              search_word: this.searchWordInput,
              js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
              /*  user_id */
            })
              .then(() => {
                this.isLoading = false;
              })
              .catch(err => {
                this.isLoading = false;

                new Error(err);
              });
          })
          .catch(err => {
            this.isLoading = false;
            new Error(err);
          });

        this.isSearchable = true;
      }

      if (e.target.value === 'all_employers') {
        this.selectedRecordFilter = e.target.value;
        this.isEmployerSelected = false;
        this.isLoading = true;
        this.isSearchable = true;

        this.retrieveLogActions()
          .then(() => {
            this.isLoading = true;

            this.retrieveLogs({
              page: this.currentPage,
              count: this.pageCount,
              record_filter: this.selectedRecordFilter,
              action_filter: this.action,
              js_employer_id: this.selectedRecordFilter,
              search_word: this.searchWordInput,
              js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
            })
              .then(() => {
                this.isLoading = false;
              })
              .catch(err => {
                this.isLoading = false;

                new Error(err);
              });
          })
          .catch(err => {
            this.isLoading = false;
            new Error(err);
          });
      }

      if (
        e.target.value !== 'all_candidates' &&
        e.target.value !== 'all_employers' &&
        e.target.value !== 'all_records' &&
        e.target.value !== 'all_internal_users'
      ) {
        this.selectedRecordFilter = e.target.value;
        this.isEmployerSelected = true;
        this.retrieveLogActions()
          .then(() => {
            this.isLoading = true;

            this.retrieveLogs({
              page: this.currentPage,
              count: this.pageCount,
              record_filter: this.selectedRecordFilter,
              action_filter: this.action,
              js_employer_id: this.selectedRecordFilter,
              search_word: this.searchWordInput,
              js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
            })
              .then(() => {
                this.isLoading = false;
              })
              .catch(err => {
                this.isLoading = false;

                new Error(err);
              });
          })
          .catch(err => {
            this.isLoading = false;
            new Error(err);
          });

        this.isLoading = false;
        this.isSearchable = false;
      }
    },
    /* Pagination */
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;

        this.retrieveLogs({
          page: this.currentPage,
          count: this.pageCount,
          record_filter: this.selectedRecordFilter,
          action_filter: this.action,
          js_employer_id: this.selectedRecordFilter,
          search_word: this.searchWordInput,
          js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        --this.currentPage;
        this.isLoading = true;

        this.retrieveLogs({
          page: this.currentPage,
          count: this.pageCount,
          record_filter: this.selectedRecordFilter,
          action_filter: this.action,
          js_employer_id: this.selectedRecordFilter,
          search_word: this.searchWordInput,
          js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            new Error(err);
          });
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.currentPage = 1;

      this.retrieveLogs({
        page: this.currentPage,
        count: this.pageCount,
        record_filter: this.selectedRecordFilter,
        action_filter: this.action,
        js_employer_id: this.selectedRecordFilter,
        search_word: this.searchWordInput,
        js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          new Error(err);
        });
    },
    setToLastPage(lastPage) {
      this.currentPage = lastPage;

      this.retrieveLogs({
        page: this.currentPage,
        count: this.pageCount,
        record_filter: this.selectedRecordFilter,
        action_filter: this.action,
        js_employer_id: this.selectedRecordFilter,
        search_word: this.searchWordInput,
        js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          new Error(err);
        });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;

      this.retrieveLogs({
        page: this.currentPage,
        count: this.pageCount,
        record_filter: this.selectedRecordFilter,
        action_filter: this.action,
        js_employer_id: this.selectedRecordFilter,
        search_word: this.searchWordInput,
        js_employer_id: this.isEmployerSelected ? this.selectedRecordFilter : null,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          new Error(err);
        });
    },
  },
  computed: {
    ...mapGetters([
      'getToken',
      'getEmployersDropdown',
      'getLogs',
      'getLogActions',
      'getCurrentPage',
      'getNextPage',
      'getTotalPages',
      'getUsersByEmployer',
      'getUserProfile',
      'getAllInternalUsers',
    ]),
    getLogsListMsg() {
      return MESSAGES.noLogs;
    },
  },
  created() {
    // Create a debounced version of the doTheSearch method
    this.debouncedSearch = debounce(this.onSearch, 300);
  },
  mounted() {
    this.isLoading = true;
    this.retrieveEmployersDropdown();
    // TODO: remove this
    this.retrieveLogs({
      page: this.currentPage,
      count: this.pageCount,
      record_filter: 'all_records',
      action_filter: this.action,
    })
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
    /* end */

    this.retrieveLogActions()
      .then(() => {
        this.retrieveLogs({
          page: this.currentPage,
          count: this.pageCount,
          record_filter: 'all_records',
          action_filter: this.action,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            throw err;
          });
      })
      .catch(err => {
        this.isLoading = false;
        if (err.response.status == 401) {
          localStorageHelper();

          this.$toasted.error('Your session is expired!', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });

          this.$router.push('/');
        }

        throw err;
      });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

/deep/ .vs__search {
  /* height: calc(1.5em + 0.75rem + 2px); */
  padding: 0.1rem;
}

.select-user {
  .vs--searchable,
  .vs--unsearchable {
    width: 580px !important;
    box-shadow: 0px 2px 3px #0000000d;
    /*  border: 1px solid #d7dae2; */
    -webkit-appearance: none;
    -moz-appearance: none;
  }
}

.logs-controls {
  font-family: $font-family-sans-lato;
  font-size: 1rem;

  .input-group {
    i {
      color: $color-table-location;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 0.25rem !important;
    }
  }
}

.mobile-lists {
  display: none;
}

@media only screen and (max-width: 1251px) {
}

@media only screen and (max-width: 992px) {
  .logs-controls {
    .d-flex {
      display: block !important;
      padding: 0 7px;
      .select-user,
      .form-control {
        margin: 12px 0 12px 0 !important;
      }
      .form-control {
        padding-left: 5px;
        box-shadow: none;
      }
    }
  }

  #wrapper {
    .card {
      min-height: calc(100vh - 64px) !important;
    }
  }
  .mobile-lists {
    h6 {
      background: #fff;
      margin: 20px 0 0 0;
      padding: 12px 15px 0px 15px;
      font-size: 1.2rem;
    }

    display: block;
    width: 100%;
    .list-unstyled {
      font-family: $font-family-sans-lato;
      background: #fff;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 15px 15px 15px;
        .user {
          display: block;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 4px;
          text-decoration: none;
        }
        .company {
          color: #333;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
        }
        .location,
        .job-position,
        .date,
        .rec {
          font-size: 14px;
        }
        .location {
          color: $color-orange;
        }
        .job-position {
          color: #666;
        }
        .logs {
          text-transform: uppercase;
          font-size: 12px;
          margin-right: 12px;
          font-weight: 600;
          color: #666;
        }
      }
    }
  }
  .desktop-only {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  #wrapper {
    .card {
      min-height: calc(100vh - 62px) !important;
    }
  }
}

@media only screen and (max-width: 576px) {
  #wrapper {
    .card {
      min-height: calc(100vh - 65px) !important;
    }
  }
}
</style>
